import React from "react";
import { Box, Typography, ButtonBase } from "@mui/material";

import necklaceImg from "../assests/necklace.webp";
import earringsImg from "../assests/earrings.webp";
import ringsImg from "../assests/rings.webp";
import karasImg from "../assests/karas.webp";
import braceletsImg from "../assests/bracelets.webp";
import bridalSetImg from "../assests/bridalset.webp";

import RingSection from "./ringSection";

const categories = [
  {
    label: "NECKLACES & PENDANTS",
    image: necklaceImg,
    href: "/products-listing?type=necklace",
  },
  {
    label: "EARRINGS",
    image: earringsImg,
    href: "/products-listing?type=earrings",
  },
  {
    label: "RINGS",
    image: ringsImg,
    href: "/products-listing?type=ring",
  },
  {
    label: "BRACELETS",
    image: braceletsImg,
    href: "/products-listing?type=bracelet",
  },
  {
    label: "KARAS",
    image: karasImg,
    href: "/products-listing?type=karas",
  },
  {
    label: "BRIDAL SETS",
    image: bridalSetImg,
    href: "/products-listing?type=bridal-sets",
  },
];

const ShopByCategory: React.FC = () => {
  return (
    <>
      <Box
        sx={{
          py: { xs: 8, md: 10 },
          px: { xs: 2, sm: 4, md: 8 },
          bgcolor: "#fff",
        }}
      >
        {/* Section Title */}
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            fontFamily: "Playfair Display, serif",
            fontWeight: 500,
            letterSpacing: 0.5,
            fontSize: { xs: 28, md: 40 },
            mb: { xs: 4, md: 6 },
            textTransform: "uppercase",
          }}
        >
          Our Selections
        </Typography>

        {/* Cards in ONE row on desktop */}
        <Box
          sx={{
            display: "grid",
            gap: { xs: 3, md: 2 },
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              md: "repeat(6, minmax(0, 1fr))",
            },
            justifyItems: "stretch",
          }}
        >
          {categories.map((cat) => (
            <ButtonBase
              key={cat.label}
              href={cat.href}
              sx={{
                display: "block",
                width: "100%",
                borderRadius: "16px",
                overflow: "hidden",
                textAlign: "left",
                backgroundColor: "#fafafa",
                transition: "transform 0.4s ease, box-shadow 0.4s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
                },
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  aspectRatio: "4/3.2",
                  overflow: "hidden",
                }}
              >
                <Box
                  component="img"
                  loading="lazy"
                  decoding="async"
                  src={cat.image}
                  alt={cat.label}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.5s ease",
                    "&:hover": { transform: "scale(1.07)" },
                  }}
                />
              </Box>

              {/* Text Overlay at bottom */}
              <Box sx={{ p: 2.5 }}>
                <Typography
                  sx={{
                    fontFamily: "Playfair Display, serif",
                    fontWeight: 600,
                    fontSize: { xs: 18, md: 20 },
                    color: "#111",
                    mb: 0.5,
                  }}
                >
                  {cat.label}
                </Typography>

                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    color: "#111",
                    fontSize: 14,
                    fontWeight: 500,
                    letterSpacing: 0.3,
                    textTransform: "uppercase",
                  }}
                >
                  Shop Now{" "}
                  <Box
                    component="span"
                    sx={{
                      fontSize: 18,
                      lineHeight: 0,
                      transform: "translateY(1px)",
                    }}
                  >
                    →
                  </Box>
                </Typography>
              </Box>
            </ButtonBase>
          ))}
        </Box>
      </Box>
      <RingSection />
    </>
  );
};

export default ShopByCategory;
